import { useState } from 'react'
import AppBar from '@mui/material/AppBar'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { useAuth } from '../../context/auth'
import NavDrawer from './NavDrawer'
import MenuIcon from '@mui/icons-material/Menu'
import AccountCircle from '@mui/icons-material/AccountCircle'

const StyledTooltip = styled(Tooltip)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: 'rgba(0, 0, 0, 0.87)',
  boxShadow: theme.shadows[1],
  fontSize: 11,
}))

const NavBar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  const [profileAnchorEl, setProfileAnchorEl] = useState(null)
  const { isAuthenticated, logout, user } = useAuth()
  // console.debug('Navbar: ', isAuthenticated)
  // console.debug('Navbar: ', user)

  const isProfileMenuOpen = Boolean(profileAnchorEl)

  const handleProfileMenuOpen = event => {
    setProfileAnchorEl(event.currentTarget)
  }

  const handleProfileMenuClose = () => {
    setProfileAnchorEl(null)
  }

  const handleMenuClose = () => {
    setMenuOpen(false)
  }

  const handleMenuOpen = () => {
    setMenuOpen(true)
  }

  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          {isAuthenticated && (
            <IconButton edge="start" sx={{ marginRight: 2 }} color="inherit" aria-label="menu" onClick={handleMenuOpen} size="large">
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
            CMS
          </Typography>

          {isAuthenticated && (
            <div>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
                size="large"
              >
                {user && (
                  <StyledTooltip title={user.name}>
                    <Avatar alt={user.name} src={user.picture} />
                  </StyledTooltip>
                )}
                {!user && <AccountCircle />}
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={profileAnchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                //keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={isProfileMenuOpen}
                onClose={handleProfileMenuClose}
              >
                <MenuItem onClick={handleProfileMenuClose}>Profile</MenuItem>
                <MenuItem onClick={logout}>Logout</MenuItem>
              </Menu>
            </div>
          )}
          {!isAuthenticated && <Button color="inherit">Login</Button>}
        </Toolbar>
      </AppBar>
      <NavDrawer open={isMenuOpen} handleDrawerClose={handleMenuClose} />
    </div>
  )
}

export default NavBar
